module.exports = __webpack_public_path__ + "8307569b9e1eaf14f125a98e227e26ce.png";